import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const Forgotpassword = () => {
  const [email, setEmail] = useState("");
  const [storedEmail, setStoredEmail] = useState(""); 
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email) {
      setError("Please enter your email address");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address");
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/password/forgot`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            email: email,
            role: "user",
          }),
        }
      );

      const data = await response.json();

      if (response.ok && data.status === "success") {
        setStoredEmail(email); 
        setIsEmailSent(true);
        setEmail(""); 
      } else {
        setError(data.message || "Failed to send recovery email. Please try again.");
      }
    } catch (err) {
      console.error("Forgot password error:", err);
      setError("Server error. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleResend = async () => {
    setIsLoading(true);
    setError("");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/password/forgot`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            email: storedEmail, 
            role: "user",
          }),
        }
      );

      const data = await response.json();

      if (!response.ok || data.status !== "success") {
        setError(data.message || "Failed to resend email.");
      }
    } catch (err) {
      setError("Failed to resend email. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="page-bg">
      <div style={{ position: "absolute", top: "2rem", left: "2rem", zIndex: "10" }}>
        <Link to="/">
          <button className="navbar-btn-secondary">
            ← Back to Home
          </button>
        </Link>
      </div>

      <Link to="/">
        <img
          src="/json-media/img/logo.svg"
          alt="GI"
          width={50}
          style={{ padding: 5 }}
        />
      </Link>

      <div className="content-center">
        <div className="forgot-password-container">
          {!isEmailSent ? (
            <div className="forgot-password-content">
              <h1 className="forgot-password-title">Recover your password</h1>
              <p className="forgot-password-subtitle">
                Enter your email address below and we'll send you an email with
                instructions to recover your password
              </p>
              <form onSubmit={handleSubmit} className="forgot-password-form">
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    id="email"
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isLoading}
                  />
                  {error && <span className="error-text">{error}</span>}
                </div>
                <button
                  type="submit"
                  className="forgot-password-submit"
                  disabled={isLoading}
                >
                  {isLoading ? "Sending..." : "Send Recovery Email"}
                </button>
                <Link to="/log-in" className="forgot-password-back">
                  Back to Log In
                </Link>
              </form>
            </div>
          ) : (
            <div className="forgot-password-content">
              <div className="forgot-password-icon">
                <Mail size={48} />
              </div>
              <h1 className="forgot-password-title">Check Your Email</h1>
              <p className="forgot-password-subtitle">
                Please check your email inbox and click on the provided link to
                reset your password. If you don't see the email, check your spam folder.
              </p>
              {error && <span className="error-text">{error}</span>}
              <button
                onClick={handleResend}
                className="forgot-password-resend"
                disabled={isLoading}
              >
                {isLoading ? "Sending..." : "Resend email"}
              </button>
              <Link to="/log-in" className="forgot-password-back">
                Back to Log In
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Forgotpassword;
